import { useState } from "react";
import { accountService, homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useDebounce } from "@miplatform/hooks";
import { buildSearchQuery } from "@miplatform/utils";

export const useHomeAndAccountSearchViewModel = ({ homeFilters = {} }) => {
  const [search, setSearch] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [homes, setHomes] = useState([]);

  const stateManager = useComponentState();
  const debouncedSearch = useDebounce(search);

  const getHomes = () =>
    stateManager.run(async () => {
      const searchQuery = buildSearchQuery(debouncedSearch, [
        "address.addressLine1",
        "accountName",
      ]);
      const { data, status } = await homeService.homes.getAll({
        filters: {
          ...searchQuery,
          ...homeFilters,
        },
      });

      if (status === HTTP_STATUSES.OK) {
        setHomes(data);
      }
    });

  const getAccounts = (filterByAccountTypes = []) => {
    stateManager.run(async () => {
      const searchQuery = buildSearchQuery(debouncedSearch, ["name"]);
      const { status, data } = await accountService.accounts.getAll({
        filters: {
          ...(filterByAccountTypes.length && {
            accountType: { in: filterByAccountTypes },
          }),
          ...searchQuery,
        },
        sort: "name asc",
        top: 100,
      });
      if (status === HTTP_STATUSES.OK) {
        setAccounts(data);
      }
    });
  };

  return {
    accounts,
    search,
    debouncedSearch,
    homes,
    setSearch,
    getHomes,
    getAccounts,
  };
};
